// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class LoginResponse extends APIModel {
    /**
    * JWT Token
    */
    accessToken: string;
    /**
    * Minimal version of client
    */
    clientVersionMin: string;
    /**
    * Version of theme
    */
    themeVersion: string;
    /**
    * Flag if maintenance is in progress
    */
    maintenanceInProgress: boolean;
    workerId: number;

    constructor(options?: APIModelOptions) {
        super(LoginResponse.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "accessToken", type: "string" },
            { name: "clientVersionMin", type: "string" },
            { name: "themeVersion", type: "string" },
            { name: "maintenanceInProgress", type: "boolean" },
            { name: "workerId", type: "number" }
        ];
    }
}




